module.exports = __webpack_public_path__ + "media/images/flags/32/Bahamas-715eac25a8da3a6cf79fa13f91cbf400.png";